import React, { Component } from "react";
import firebase from "../Firebase";
import Swal from "sweetalert2";
import { pickLatestEmployeeDoc } from "../utils/employeeIdentity";

class Login extends Component {
  constructor() {
    super();
    this.db = firebase.firestore().collection("employees");
    this.unsubscribe = null;
    this.state = {
      nik: "",
      tanggal_lahir: "",
      isLoading: false,
    };
  }

  componentDidMount() {
    this.getCurrentDate();
    this.cekLogin();
  }

  kasihNol = (data) => {
    if (data < 10) {
      return "0" + data;
    } else {
      return data;
    }
  };

  date = () => {
    const hmm = this;
    const today = new Date();
    const time =
      hmm.kasihNol(today.getHours()) +
      ":" +
      hmm.kasihNol(today.getMinutes()) +
      ":" +
      hmm.kasihNol(today.getSeconds());
    const date =
      hmm.kasihNol(today.getDate()) +
      "/" +
      hmm.kasihNol(today.getMonth() + 1) +
      "/" +
      hmm.kasihNol(today.getFullYear());
    hmm.setState({
      date: date,
      time: time,
    });
  };

  getCurrentDate = () => {
    const hmm = this;
    hmm.date();
    setInterval(function () {
      hmm.date();
    }, 1000);
  };

  // Normalisasi tanggal lahir: angka saja, 8 digit (DDMMYYYY). Dipakai untuk input user & nilai dari Firebase.
  normalizeTanggalLahir = (val) => {
    const s = String(val ?? "")
      .trim()
      .replace(/\D/g, "");
    return s.length === 7 ? "0" + s : s;
  };

  // Samakan format tanggal lahir 6 digit (DDMMYY) dan 8 digit (DDMMYYYY).
  isTanggalLahirMatch = (inputVal, dbVal) => {
    const a = this.normalizeTanggalLahir(inputVal);
    const b = this.normalizeTanggalLahir(dbVal);

    if (!a || !b) return false;
    if (a === b) return true;

    // Cocokkan DDMMYY <-> DDMMYYYY berdasarkan 2 digit tahun terakhir.
    if (a.length === 6 && b.length === 8) {
      return a.slice(0, 4) === b.slice(0, 4) && a.slice(4) === b.slice(6);
    }
    if (a.length === 8 && b.length === 6) {
      return a.slice(0, 4) === b.slice(0, 4) && a.slice(6) === b.slice(4);
    }

    return false;
  };

  doSubmit = (e) => {
    e.preventDefault();
    this.setState({
      isLoading: true,
    });

    const nik = String(this.state.nik || "").trim();
    const tanggal_lahir = this.normalizeTanggalLahir(this.state.tanggal_lahir);

    console.log("🔐 Login attempt:", {
      raw: { nik: this.state.nik, tanggal_lahir: this.state.tanggal_lahir },
      normalized: { nik, tanggal_lahir },
    });

    const self = this;
    const normalizedTgl = tanggal_lahir;

    const processDocs = (docs) => {
      const matched = docs.filter((doc) => {
        const data = doc.data();
        const fbNik = String(data.nik ?? "").trim();
        return (
          fbNik === nik &&
          self.isTanggalLahirMatch(normalizedTgl, data.tanggal_lahir)
        );
      });
      return matched;
    };

    const runLoginSuccess = (matchedDocs) => {
      this.setState({ isLoading: false });
      // Jika ada duplikat NIK, pakai dokumen paling baru saja
      const preferred =
        matchedDocs.length === 1
          ? matchedDocs[0]
          : pickLatestEmployeeDoc(matchedDocs) || matchedDocs[0];

      console.log("👤 Employee data found:", {
        docId: preferred.id,
        nik: preferred.data().nik,
        tanggal_lahir: preferred.data().tanggal_lahir,
        duplicateCount: matchedDocs.length,
      });
      console.log("✅ Login successful! User data found");
      Swal.fire({
        title: "Login Berhasil !",
        text:
          matchedDocs.length > 1
            ? `Data ditemukan (ada ${matchedDocs.length} duplikat; memakai data terbaru)`
            : "Data ditemukan, login berhasil",
        icon: "success",
        showCancelButton: false,
        confirmButtonText: "Oke",
      }).then((result) => {
        const fullData = preferred.data();
        const limitedData = [
          {
            docId: preferred.id,
            nik: fullData.nik,
            tanggal_lahir: fullData.tanggal_lahir,
            status_karyawan: fullData.status_karyawan,
            username_admin: fullData.username_admin,
            status: fullData.status,
            form_1_submitted: fullData.form_1_submitted,
            form_1_submitted_date: fullData.form_1_submitted_date,
            form_2_submitted: fullData.form_2_submitted,
            form_2_submitted_date: fullData.form_2_submitted_date,
            form_3_submitted: fullData.form_3_submitted,
            form_3_submitted_date: fullData.form_3_submitted_date,
          },
        ];
        console.log("💾 Saving to localStorage:", limitedData);
        localStorage.setItem("id", JSON.stringify(limitedData));
        window.location.href = "/form";
      });
    };

    const nikNum = /^\d+$/.test(nik) ? parseInt(nik, 10) : null;
    const tglNum = /^\d+$/.test(tanggal_lahir)
      ? parseInt(tanggal_lahir, 10)
      : null;

    const tryQueryThenNext = (queryPromise, fallback) => {
      queryPromise
        .then((snap) => {
          let matched = processDocs(snap.docs);
          if (matched.length > 0) {
            runLoginSuccess(matched);
            return;
          }
          fallback();
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          console.error("🔥 Firebase query error:", err);
          Swal.fire({
            title: "Error !",
            text:
              "Terjadi kesalahan saat mengecek data: " + (err && err.message),
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "Oke",
          });
        });
    };

    const showLoginFailed = () => {
      this.setState({ isLoading: false });
      Swal.fire({
        title: "Login Gagal !",
        text: "Mohon maaf. Data kamu belum ada di system",
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Oke",
      }).then((result) => {
        window.location.reload();
      });
    };

    const runFallbackByTanggal = () => {
      const qTglStr = firebase
        .firestore()
        .collection("employees")
        .where("tanggal_lahir", "==", tanggal_lahir);
      const qTglNum =
        tglNum != null
          ? firebase
              .firestore()
              .collection("employees")
              .where("tanggal_lahir", "==", tglNum)
          : null;
      tryQueryThenNext(qTglStr.get(), () => {
        if (qTglNum) {
          tryQueryThenNext(qTglNum.get(), showLoginFailed);
        } else {
          showLoginFailed();
        }
      });
    };

    try {
      // 1) Coba by NIK string
      const qNikStr = firebase
        .firestore()
        .collection("employees")
        .where("nik", "==", nik);
      tryQueryThenNext(qNikStr.get(), () => {
        // 2) Fallback: NIK di Firestore tipe number
        if (nikNum != null) {
          const qNikNum = firebase
            .firestore()
            .collection("employees")
            .where("nik", "==", nikNum);
          tryQueryThenNext(qNikNum.get(), runFallbackByTanggal);
        } else {
          runFallbackByTanggal();
        }
      });
    } catch (e) {
      this.setState({ isLoading: false });
      console.error("💥 Catch block error:", e);
      Swal.fire({
        title: "Error !",
        text: "Terjadi kesalahan: " + (e && e.message),
        icon: "error",
        showCancelButton: false,
        confirmButtonText: "Oke",
      });
    }
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  cekLogin = () => {
    const id = localStorage.getItem("id");
    if (id != null) {
      // Ini sudah login, masuk ke form
      this.props.history.push("/form");
    }
  };

  render() {
    return (
      <div className="">
        <nav className="main-header-navbar navbar-expand-lg navbar navbar-with-menu bg-white">
          <div className="container-fluid">
            <div className="navbar-wrapper" style={{ width: "100%" }}>
              <div className="navbar-container">
                <div className="navbar-collapse" id="navbar-mobile">
                  <div className="mr-auto float-left bookmark-wrapper d-flex align-items-center logo-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-row">
                        <li className="nav-item mr-auto">
                          <a className="navbar-brand" href="/">
                            <div className="brand-logo">
                              <img
                                alt="Logo"
                                className="logo"
                                src={require("../assets/logos/logo-pas.jpg")}
                              />
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mr-auto bookmark-wrapper d-flex align-items-center header-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-column">
                        <li className="nav-item text-center">
                          <h1 className="font-header">
                            PT. PRAKARSA ALAM SEGAR
                          </h1>
                        </li>
                        <li className="nav-item text-center">
                          <h2 className="font-sub-header">
                            Human Resource Department
                          </h2>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="bookmark-wrapper d-flex align-items-center time-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-column">
                        <li className="nav-item text-right">
                          <span className="font-date">{this.state.date}</span>
                        </li>
                        <li className="nav-item text-right">
                          <span className="font-time">{this.state.time}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className="pembatas"></div>
        <div className="app-content content" style={{ margin: "0" }}>
          <div className="content-overlay"></div>
          <div className="content-wrapper mb-2">
            <div className="content-header row"></div>
            <div className="content-body">
              <section id="auth-login" className="row flexbox-container">
                <div className="col-md-4 col-11" style={{ margin: "0 auto" }}>
                  <div className="card bg-authentication mb-0">
                    <div className="row m-0">
                      <div className="col-md-12 col-12 px-0">
                        <div className="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center">
                          <div className="card-header pb-1">
                            <div className="card-title">
                              <h4 className="text-center mb-0">
                                Kamu Harus Login
                              </h4>
                            </div>
                          </div>
                          <div className="card-content">
                            <div className="card-body">
                              <div className="divider">
                                <div className="divider-text text-uppercase text-muted">
                                  <small>
                                    Login Dengan NIK & Tanggal Lahir
                                  </small>
                                </div>
                              </div>
                              <form onSubmit={this.doSubmit}>
                                <div className="form-group mb-50">
                                  <label
                                    className="text-bold-600"
                                    htmlFor="nik"
                                  >
                                    NIK ( Nomor KTP )
                                  </label>
                                  <input
                                    required
                                    onChange={this.onChange}
                                    value={this.state.nik}
                                    name="nik"
                                    type="text"
                                    className="form-control"
                                    id="nik"
                                    placeholder="16 Digit nomor KTP"
                                  />
                                </div>
                                <div className="form-group">
                                  <label
                                    className="text-bold-600"
                                    htmlFor="tanggal-lahir"
                                  >
                                    Tanggal Lahir (TanggalBulanTahun)
                                  </label>
                                  <input
                                    required
                                    onChange={this.onChange}
                                    value={this.state.tanggal_lahir}
                                    name="tanggal_lahir"
                                    type="text"
                                    className="form-control"
                                    id="tanggal-lahir"
                                    placeholder="Contoh : 20031998"
                                  />
                                </div>
                                <button
                                  disabled={this.state.isLoading}
                                  type="submit"
                                  className="btn login-button glow w-100 position-relative text-white"
                                >
                                  {this.state.isLoading === true ? (
                                    <span className="text-white">
                                      <i className="bx bx-spin bx-loader"></i>{" "}
                                      Memeriksa..
                                    </span>
                                  ) : (
                                    <span>
                                      Login
                                      <i
                                        id="icon-arrow"
                                        className="bx bx-right-arrow-alt"
                                      ></i>
                                    </span>
                                  )}
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
